import Seo from "../components/Seo";
import BlogHtmlContent from "../components/BlogHtmlContent";
import { BLOG_INDEX } from "./blogs/blogRegistry";
import { BLOG_IMAGES } from "./blogs/blogImages";
import { SITE_NAME, SITE_URL } from "../seo/site";

function BlogIndexPage({ onAdvisorClick }) {
  return <main className="vd-page vd-blog-page">
      <Seo
        title={BLOG_INDEX.title}
        description={BLOG_INDEX.description}
        path="/blog"
        image={`${SITE_URL}${BLOG_IMAGES.featured.src}`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Blog",
          name: `${SITE_NAME} Guides`,
          url: `${SITE_URL}/blog`,
          description: BLOG_INDEX.description,
          image: `${SITE_URL}${BLOG_IMAGES.featured.src}`
        }}
      />

      <section className="vd-page-hero">
        <div className="vd-page-hero-inner">
          <p className="vd-page-kicker">Blog</p>
          <h1>Real Estate Research &amp; Verification Guides</h1>
          <p className="vd-page-lead">
            Expert guides on RERA verification, HMDA/DTCP approvals, plot due diligence, and smarter property research.
          </p>
        </div>
      </section>

      <BlogHtmlContent
        styles={BLOG_INDEX.styles}
        html={BLOG_INDEX.bodyHtml}
        onAdvisorClick={onAdvisorClick}
      />
    </main>;
}

export default BlogIndexPage;
